// PROTOTYPE STRING

if (!String.prototype.format){
	String.prototype.format = function(){
		var args = arguments;
		return this.replace(/{(\d+)}/g, function(match, number) {
			return typeof args[number] !== 'undefined'
				? args[number]
				: match
				;
		});
	};
}

if (!String.prototype.trim) {
	String.prototype.trim = function(){
		return this.replace(/^\s+/, '').replace(/\s+$/, '');
	};
}

if (!String.prototype.trimChar) {
	String.prototype.trimChar = function (charToRemove) {
		var str = this;

		while(str.charAt(0) == charToRemove) {
			str = str.substring(1);
		}

		while(str.charAt(str.length-1) == charToRemove) {
			str = str.substring(0, str.length-1);
		}

		return str;
	}
}

if (!String.prototype.nullOrWhitespace) {
	String.prototype.nullOrWhitespace = function(){
		return this.trim() === '';
	}
}

if (!String.prototype.notNullOrWhitespace) {
	String.prototype.notNullOrWhitespace = function(){
		return !this.nullOrWhitespace();
	}
}

if (!String.prototype.slugify) {
	String.prototype.slugify = function(){
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return this.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	}
}

if (!String.prototype.padStart) {
	String.prototype.padStart = function(length, padValue) {
		var strThis = this;

		while (strThis.length < length) {
			strThis = padValue + strThis;
		}

		return strThis;
	}
}


if (!String.prototype.rangeCap) {
	String.prototype.rangeCap = function(min, max) {
		var number = parseInt(this);

		return (isNaN(number))
			? min
			: number.rangeCap(min, max);
	}
}


if (!String.prototype.inRange) {
	String.prototype.inRange = function(min, max) {
		var number = parseInt(this);
		return number.inRange(min, max);
	}
}




// PROTOTYPE NUMBER

if (!Number.prototype.toTimer) {
	Number.prototype.toTimer = function() {
		var nrSeconds = this;

		var secs  = Math.floor(nrSeconds % 60);
		var mins  = Math.floor((nrSeconds / 60) % 60);
		var hours = Math.floor((nrSeconds / (60 * 60)));

		var strSecs  = new String(secs).padStart(2, '0');
		var strMins  = new String(mins).padStart(2, '0');
		var strHours = new String(hours).padStart(2, '0');

		return '{0}:{1}:{2}'.format(strHours, strMins, strSecs);
	}
}


if (!Number.prototype.rangeCap) {
	Number.prototype.rangeCap = function(min, max) {
		var number = this.valueOf();

		return (number < min) ? min
			: (number > max) ? max
			: number;
	}
}


if (!Number.prototype.inRange) {
	Number.prototype.inRange = function(min, max, inclusive = false) {
		var number = this.valueOf();
		return (inclusive)
			? (number >= min && number <= max)
			: (number >= min && number < max);
	}
}


if (!Number.prototype.secondsToDHM) {
	Number.prototype.secondsToDHM = function() {
		const secsPerDay = 86400;
		const secsPerHour = 3600;
		const secsPerMinute = 60;

		var seconds = Math.abs(this);
		var minus   = (this < 0) ? '-' : '';

		var days    = Math.floor(seconds / secsPerDay);
		seconds     = (seconds % secsPerDay);
		var hours   = Math.floor(seconds / secsPerHour);
		seconds     = (seconds % secsPerHour);
		var minutes = Math.floor(seconds / secsPerMinute);
		seconds     = (seconds % secsPerMinute);

		var sDays    = new String(days).padStart(1, '0');
		var sHours   = new String(hours).padStart(2, '0');
		var sMinutes = new String(minutes).padStart(2, '0');

		return `${minus}${sDays}D ${sHours}:${sMinutes}`;
	}
}


if (!Number.prototype.countDecimals) {
	Number.prototype.countDecimals = function() {
		var strings = this.valueOf()?.toString()?.split(".") ?? [];
		return (strings.length >= 2) ? strings[1].length : 0;
	}
}


if (!Number.prototype.toNrDecimals) {
	Number.prototype.toNrDecimals = function (minDecs = 0, maxDecs = 2) {
		// ensure maxDecs not lower than minDecs
		maxDecs = (maxDecs < minDecs) ? minDecs : maxDecs;

		// get this num
		var num = this?.valueOf() ?? 0;

		// round at max decs; this removes zeroes in the upcoming string format
		num = +num.toFixed(maxDecs);

		// to string
		let strNum = num.toString();

		// determine nr decimals & zero pads
		let decimalIndex = strNum.indexOf('.');
		let noPeriod     = (decimalIndex === -1);
		let nrDecs       = (noPeriod) ? 0 : (strNum.length - decimalIndex - 1);
		let nrZeroPads   = (minDecs - nrDecs);
		let needsPadding = (nrZeroPads > 0);

		// create zero padding string
		let strZeroPads = (needsPadding) ? '0'.repeat(nrZeroPads) : '';

		// return value
		return (noPeriod && needsPadding)
			? `${strNum}.${strZeroPads}`
			: `${strNum}${strZeroPads}`;
	}
}



if (!Number.prototype.toFixedNumber) {
	Number.prototype.toFixedNumber = function(digits){
		var strNum = this.toFixed(digits);
		return Number(strNum);
	}
}







// PROTOTYPE DATE

if (!Date.prototype.addSeconds){
	Date.prototype.addSeconds = function(seconds) {
		this.setSeconds(this.getSeconds() + seconds);
		return this;
	};
}

if (!Date.prototype.addMinutes){
	Date.prototype.addMinutes = function(minutes) {
		this.setMinutes(this.getMinutes() + minutes);
		return this;
	};
}

if (!Date.prototype.addHours){
	Date.prototype.addHours = function(hours) {
		this.setHours(this.getHours() + hours);
		return this;
	};
}

if (!Date.prototype.addDays){
	Date.prototype.addDays = function(days) {
		this.setDate(this.getDate() + days);
		return this;
	};
}

if (!Date.prototype.addWeeks){
	Date.prototype.addWeeks = function(weeks) {
		this.addDays(weeks*7);
		return this;
	};
}

if (!Date.prototype.addMonths){
	Date.prototype.addMonths = function(months) {
		var dt = this.getDate();

		this.setMonth(this.getMonth() + months);
		var currDt = this.getDate();

		if (dt !== currDt) {
			this.addDays(-currDt);
		}

		return this;
	};
}

if (!Date.prototype.addYears){
	Date.prototype.addYears = function(years) {
		var dt = this.getDate();

		this.setFullYear(this.getFullYear() + years);

		var currDt = this.getDate();

		if (dt !== currDt) {
			this.addDays(-currDt);
		}

		return this;
	};
}

if (!Date.prototype.getYMDHMS){
	Date.prototype.getYMDHMS = function(){
		return {
			fullYear : (this.getFullYear()).toString().padStart(4, '0'),
			month    : (this.getMonth() + 1).toString().padStart(2, '0'),
			day      : (this.getDate()).toString().padStart(2, '0'),
			hours    : (this.getHours()).toString().padStart(2, '0'),
			minutes  : (this.getMinutes()).toString().padStart(2, '0'),
			seconds  : (this.getSeconds()).toString().padStart(2, '0')
		};
	}
}

if (!Date.prototype.toYMD){
	Date.prototype.toYMD = function(offSetHours = 0){
		var ymdhms = this.addHours(offSetHours).getYMDHMS();
		return '{0}-{1}-{2}'.format(ymdhms.fullYear, ymdhms.month, ymdhms.day);
	};
}

if (!Date.prototype.toYMDHM){
	Date.prototype.toYMDHM = function(offSetHours = 0){
		var ymdhms = this.addHours(offSetHours).getYMDHMS();
		return '{0}-{1}-{2} {3}:{4}'.format(ymdhms.fullYear, ymdhms.month, ymdhms.day, ymdhms.hours, ymdhms.minutes);
	};
}

if (!Date.prototype.toYMDHMS){
	Date.prototype.toYMDHMS = function(offSetHours = 0){
		var ymdhms = this.addHours(offSetHours).getYMDHMS();
		return '{0}-{1}-{2} {3}:{4}:{5}'.format(ymdhms.fullYear, ymdhms.month, ymdhms.day, ymdhms.hours, ymdhms.minutes, ymdhms.seconds);
	};
}

if (!Date.prototype.deltaMilliSeconds){
	Date.prototype.deltaMilliSeconds = function(otherDate){
		return this.getTime() - otherDate.getTime();
	};
}

if (!Date.prototype.deltaSeconds){
	Date.prototype.deltaSeconds = function(otherDate){
		return this.deltaMilliSeconds(otherDate) / 1000;
	};
}

if (!Date.prototype.deltaHours){
	Date.prototype.deltaHours = function(otherDate){
		return this.deltaSeconds(otherDate) / 3600;
	};
}

if (!Date.prototype.deltaDays){
	Date.prototype.deltaDays = function(otherDate){
		return this.deltaHours(otherDate) / 24;
	};
}

if (!Date.prototype.toUTC){
	Date.prototype.toUTC = function(){
		var utcOffset = new Date().getTimezoneOffset();
		var utcNow    = new Date().addMinutes(utcOffset);
		return utcNow;
	};
}

if (!Date.prototype.inRange){
	Date.prototype.inRange = function(dtMin, dtMax, inclusive = false){
		var thisTime = this.getTime();
		var minTime = dtMin.getTime();
		var maxTime = dtMax.getTime();
		return thisTime.inRange(minTime, maxTime, inclusive);
	};
}




// PROTOTYPE ARRAY

if (!Array.prototype.chunk) {
	Array.prototype.chunk = function(size) {
		array = this;
		const chunked_arr = [];
		let index = 0;
		while (index < array.length) {
			chunked_arr.push(array.slice(index, size + index));
			index += size;
		}
		return chunked_arr;
	}
}


if (!Array.prototype.flat) {
	Array.prototype.flat = function() {
		var destArray = [];
		var srcArray = arguments[0];

		for (var i = 0; i < length; i++) {
			var obj = destArray[i];
			var isArray = Array.isArray(obj);
			if (isArray) {
				for (var j = 0; j < obj.length; j++) {
					var _obj = srcArray[j];
					destArray.push(_obj);
				}
			} else {
				destArray.push(obj);
			}
		}

		return destArray;
	}
}


if (!Array.prototype.pushArray) {
	Array.prototype.pushArray = function() {
		var destArray = this;
		var sourceArray = arguments[0];

		sourceArray = (sourceArray != null) ? sourceArray : [];

		for (var i = 0; i < sourceArray.length; i++) {
			var x = sourceArray[i];
			destArray.push(x);
		}

		return destArray;
	}
}




// COMMON

window.common = (function(){

	// private functions

	function arrayToDictionary(arr) {
		var dic = {};

		for (var i = 0; i < arr.length; i++) {
			dic[arr[i]] = true;
		}

		return dic;
	}

	// private functions




	// public functions

	function getUrlParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
		var results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	function getUrlSubDirByIndex(index, url) {
		if (!url) url = window.location.pathname;
		url = url.trimChar('/');
		var sections = url.split('/');
		return (index < sections.length)
			? sections[index]
			: null;
	}

	function bytesToMegabytesString(nrBytes, decimals = 2) {
		var megabytes = (nrBytes / 1024 / 1024).toFixedNumber(decimals);
		return '{0} MB'.format(megabytes);
	}


	function getClientDateTimeString() {
		return new Date().toYMDHMS();
	}


	function getPropNameByIndex(obj, i) {
		var keys = Object.keys(obj);

		return (i < keys.length)
			? keys[i]
			: null;
	}


	function getPropValueByIndex(obj, i) {
		var keys = Object.keys(obj);

		return (i < keys.length)
			? obj[keys[i]]
			: null;
	}


	// parses a width string/number and returns a valid-css width string
	function parseWidthValue(valWidth) {
		var inputIsString = (typeof valWidth === 'string');
		var number = parseInt(valWidth);
		var validNumber = (number != NaN);
		var endsWithPx = (inputIsString) ? valWidth.endsWith('px') : false;
		var endsWithPct = (inputIsString) ? valWidth.endsWith('%') : false;
		var endsWithNothing = (!endsWithPx && !endsWithPct);

		return (validNumber && (endsWithPx || endsWithPct))
			? valWidth
			: (validNumber && endsWithNothing)
			? `${number}px`
			: '';
	}


	function deepCopy(obj, ...propsToKeep) {
		var copy = JSON.parse(JSON.stringify(obj));

		var dic = arrayToDictionary(propsToKeep);

		for (var prop in copy)
		{
			if (!dic[prop]) {
				delete copy[prop];
			}
		}

		return copy;
	}


	function getNrSecsUntilSerializedUtcEnd(serializedUtcEnd) {
		var utcOffset = new Date().getTimezoneOffset();
		var utcBegin  = new Date().addMinutes(utcOffset);
		var utcEnd    = new Date(serializedUtcEnd);
		var nrSeconds = ((utcEnd - utcBegin) / 1000);
		return nrSeconds;
	}


	function allNumbersEqual(numbers) {
		return (numbers?.length > 0)
			? numbers.every((val, i, arr) => (val === arr[0]))
			: true;
	}


	function lastNumbersEqual(numbers, equalCount) {
		var enoughNumbers = (numbers.length >= equalCount);

		return (enoughNumbers)
			? allNumbersEqual(numbers.slice(numbers.length - equalCount))
			: false;
	}


	function versionedImageUrl(url, version)
	{
		return (url && version)
			? `${url}?v=${version}`
			: url;
	}


	function debounce(func, timeout) {
		var timer;
		var that = this;
		return (...args) => {
			clearTimeout(that.timer);
			that.timer = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		};
	}


	function isAlphaNumeric(str) {
		console.log(str);
		return str.match(/^[0-9a-zA-Z]+$/);
	}


	function isAlphaNumericChar(char) {
		console.log(char);
		return char.match(/^[0-9a-zA-Z]$/);
	}


	function toCustomBase64(obj) {
		var success = false;
		var b64 = '';

		try {
			var str = JSON.stringify(obj);
			var b64 = btoa(str).replace(/\//g, '_').replace(/\+/g, '-');
			success = true;
		} catch (e) {
		}

		return { success : success, b64 : b64 };
	}


	function fromCustomBase64(str) {
		var success = false;
		var obj = null;

		try {
			str = str.replace(/_/g, '/').replace(/\-/g, '+')
			var _obj = atob(str);
			obj = JSON.parse(_obj);
			success = true;
		} catch (e) {
		}

		return { success : success, obj : obj };
	}


	function dicWhere(dic, funcWhere) {
		var dicSubSet = {};

		for (const [key, val] of Object.entries(dic)) {
			if (funcWhere(val)) {
				dicSubSet[key] = val;
			}
		}

		return dicSubSet;
	}


	function getStarImageUrls(rating) {
		// round it to halves
		var stars = Math.round(rating * 2) / 2;

		// calculate nr stars of every type
		var nrFullStars = (stars / 1) >> 0; // get quotient
		var nrHalfStars = ((stars - nrFullStars) / 0.5);
		var nrEmptyStars = (5 - nrFullStars - nrHalfStars);

		// create array
		var starValues = [];

		for (var i = 0; i < nrFullStars; i++) {
			starValues.push('/img/icons/star-full.svg');
		}

		for (var i = 0; i < nrHalfStars; i++) {
			starValues.push('/img/icons/star-half.svg');
		}

		for (var i = 0; i < nrEmptyStars; i++) {
			starValues.push('/img/icons/star-empty.svg');
		}

		return starValues;
	}


	function executeAtIntervals(funcsTimeouts) {
		for (var i = 0; i < funcsTimeouts.length; i++)
		{
			var func = funcsTimeouts[i].func;
			var timeout = funcsTimeouts[i].timeout;
			setTimeout(func, timeout);
		}
	}


	function randomString(length = 32) {
		const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const lenChars = chars.length;

		let randomChars = [];

		for (let i = 0; i < length; i++) {
			randomChars.push(
				chars[Math.floor(Math.random() * lenChars)]
			);
		}

		return randomChars.join('');
	}


	function isErrorObject(obj) {
		return Object.prototype.toString.call(obj) === '[object Error]';
	}


	function stringifySafely(obj) {
		var result;

		try {
			result = JSON.stringify(obj);
		} catch (e) {
			result = e.toString();
		}

		return result;
	}


	function toInt(value, defaultValue = 0) {
		value = (value) ? parseFloat(value) : defaultValue;
		return (!isNaN(value)) ? value : defaultValue;
	}


	function toFloat(value, defaultValue = 0) {
		value = (value) ? parseFloat(value) : defaultValue;
		return (!isNaN(value)) ? value : defaultValue;
	}

	// public functions




	return {
		getUrlParameterByName          : getUrlParameterByName,
		getUrlSubDirByIndex            : getUrlSubDirByIndex,
		bytesToMegabytesString         : bytesToMegabytesString,
		getClientDateTimeString        : getClientDateTimeString,
		getPropNameByIndex             : getPropNameByIndex,
		getPropValueByIndex            : getPropValueByIndex,
		parseWidthValue                : parseWidthValue,
		deepCopy                       : deepCopy,
		getNrSecsUntilSerializedUtcEnd : getNrSecsUntilSerializedUtcEnd,
		allNumbersEqual                : allNumbersEqual,
		lastNumbersEqual               : lastNumbersEqual,
		versionedImageUrl              : versionedImageUrl,
		debounce                       : debounce,
		isAlphaNumeric                 : isAlphaNumeric,
		isAlphaNumericChar             : isAlphaNumericChar,
		toCustomBase64                 : toCustomBase64,
		fromCustomBase64               : fromCustomBase64,
		dicWhere                       : dicWhere,
		getStarImageUrls               : getStarImageUrls,
		executeAtIntervals             : executeAtIntervals,
		randomString                   : randomString,
		isErrorObject                  : isErrorObject,
		stringifySafely                : stringifySafely,
		toInt                          : toInt,
		toFloat                        : toFloat
	}
})();